module.exports = __webpack_public_path__ + "img/dynamic_0.1e6e6416.gif";